import { DictionariesEditPage } from 'features/dictionaries/components/DictionariesEditPage'
import { DictionaryType } from 'features/dictionaries/types'

export const DictionariesTaskTypeEditPage = () => {
  return <DictionariesEditPage type={DictionaryType.TaskTypes} />
}
